import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getQueryParam } from '../../routing/getQueryParam';
import { Step } from '../../views/Step';
import { getHasExposureBeenTrackedForGooglePromptExperiment, GOOGLE_PROMPT_EXPERIMENT_EXPERIMENT_ID } from './googlePromptTracking';
export const GOOGLE_PROMPT_EXPERIMENT_TREATMENT_QUERY_PARAM = `${GOOGLE_PROMPT_EXPERIMENT_EXPERIMENT_ID}-treatment`;
const GOOGLE_PROMPT_EXPERIMENT_TREATMENTS = [ExperimentParameterGroup.Control, ExperimentParameterGroup.Variant_B, ExperimentParameterGroup.Variant_C];
export const PROMPT_DISMISSED_QUERY_PARAM = 'prompt-dismissed';
export const PROMPT_CLICKED_QUERY_PARAM = 'prompt-clicked';
export const PROMPT_NOT_CLICKED_QUERY_PARAM = 'prompt-not-clicked';
export const getIsEnrolledForGooglePromptExperiment = () => {
  const googlePromptExperimentTreatment = getQueryParam(GOOGLE_PROMPT_EXPERIMENT_TREATMENT_QUERY_PARAM);
  const hasGooglePromptExperimenTreatment = GOOGLE_PROMPT_EXPERIMENT_TREATMENTS.includes(googlePromptExperimentTreatment);
  return hasGooglePromptExperimenTreatment;
};
export const isGooglePromptExperimentVariant = () => {
  const googlePromptExperimentTreatment = getQueryParam(GOOGLE_PROMPT_EXPERIMENT_TREATMENT_QUERY_PARAM);
  const isEnrolledForGooglePromptExperiment = getIsEnrolledForGooglePromptExperiment();
  return isEnrolledForGooglePromptExperiment && googlePromptExperimentTreatment === ExperimentParameterGroup.Variant;
};
export const isOnIndustryStepAndCredentialVerifiedNewUser = (currentStep, isGoogleCredentialAuthentication, isExistingOAuthUser) => {
  return isGoogleCredentialAuthentication && currentStep === Step.Industry && !isExistingOAuthUser;
};
export const getGooglePromptQueryParameterValue = queryParam => {
  const queryParamValue = parseInt(getQueryParam(queryParam), 10);
  return queryParamValue;
};
export const checkIfIsGooglePromptExperimentAndExposureTracked = activeExperimentId => {
  if (!GOOGLE_PROMPT_EXPERIMENT_EXPERIMENT_ID) {
    return false;
  }

  return activeExperimentId === GOOGLE_PROMPT_EXPERIMENT_EXPERIMENT_ID && getHasExposureBeenTrackedForGooglePromptExperiment();
};
export const getActiveGooglePromptExperimentId = () => {
  return getHasExposureBeenTrackedForGooglePromptExperiment() ? [GOOGLE_PROMPT_EXPERIMENT_EXPERIMENT_ID] : [];
};